"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveAndRepriceTransferLine = void 0;
const _ = require("lodash");
const loadCheapestTransferRates_1 = require("./loadCheapestTransferRates");
const moveAndRepriceTransferLine = async (linked_order_line_version, new_date, supabase) => {
    const new_version = _.cloneDeep(linked_order_line_version);
    new_version.start_date = new_date;
    new_version.end_date = new_date;
    const vehicle_rates = await (0, loadCheapestTransferRates_1.loadCheapestTransferRates)(supabase, new_version.config?.transfer_legs?.outbound?.from_area, new_version.config?.transfer_legs?.outbound?.to_area, new_version.config?.transfer_legs?.inbound?.from_area, new_version.config?.transfer_legs?.inbound?.to_area, new_version.config?.where_when_who?.type, new_date, new_version.config?.where_when_who?.number_of_passengers, new_version.config?.vehicle?.vehicle?.id);
    const config = new_version.config;
    config.where_when_who.date = new_date;
    if (vehicle_rates?.outbound) {
        config.vehicle.rate.outbound = vehicle_rates.outbound[0];
    }
    if (vehicle_rates?.inbound) {
        config.vehicle.rate.inbound = vehicle_rates.inbound[0];
    }
    switch (new_version.config?.where_when_who?.type) {
        case "ONE_WAY":
            config.vehicle.cost = vehicle_rates?.outbound[0].single_cost_price;
            config.vehicle.margin = vehicle_rates?.outbound[0].single_markup;
            config.vehicle.price = vehicle_rates?.outbound[0].single_sell_price;
            config.vehicle.total =
                vehicle_rates?.outbound[0].single_sell_price * config.vehicle.quantity;
            break;
        case "RETURN":
            config.vehicle.cost = vehicle_rates?.outbound[0].return_cost_price;
            config.vehicle.margin = vehicle_rates?.outbound[0].return_markup;
            config.vehicle.price = vehicle_rates?.outbound[0].return_sell_price;
            config.vehicle.total =
                vehicle_rates?.outbound[0].return_sell_price * config.vehicle.quantity;
            break;
        case "CUSTOM":
            config.vehicle.cost =
                vehicle_rates?.outbound[0].single_cost_price +
                    vehicle_rates?.inbound[0].single_cost_price;
            config.vehicle.margin =
                vehicle_rates?.outbound[0].single_markup +
                    vehicle_rates?.inbound[0].single_markup;
            config.vehicle.price =
                vehicle_rates?.outbound[0].single_sell_price +
                    vehicle_rates?.inbound[0].single_sell_price;
            config.vehicle.total =
                (vehicle_rates?.outbound[0].single_sell_price +
                    vehicle_rates?.inbound[0].single_sell_price) *
                    config.vehicle.quantity;
            break;
    }
    new_version.config = config;
    return new_version;
};
exports.moveAndRepriceTransferLine = moveAndRepriceTransferLine;
